import { render } from "./students.vue?vue&type=template&id=51ea4c88&scoped=true"
import script from "./students.vue?vue&type=script&lang=js"
export * from "./students.vue?vue&type=script&lang=js"

import "./students.vue?vue&type=style&index=0&id=51ea4c88&scoped=true&lang=css"
import "./students.vue?vue&type=style&index=1&id=51ea4c88&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ea4c88"]])

export default __exports__